import React from "react";

type PageHeaderSlot = {
    /** The element in the top bar that page titles are portalled into; null until the top bar mounts. */
    slot: HTMLElement | null;
    setSlot: (slot: HTMLElement | null) => void;
};

/** Connects the top bar's title slot (MainHeader) with the page that fills it (PageHeader). */
export const PageHeaderSlotContext = React.createContext<PageHeaderSlot>({
    slot: null,
    setSlot: () => undefined,
});
